export enum TipoGeolocalizacao {
    Caminhao = 0,
    Navio = 1,
    Terminal = 2,
    TerminalComCarga = 3
}
